"use client"

import clsx from "clsx"
import { NpProductCarouselItem } from "src/components/home/NpProductCarouselItem"
import { NpHomePageProductData } from "src/components/home/types"
import { NpCarouselArrow } from "src/components/np-design/components/NpCarouselArrow"
import { NpPaginationDots } from "src/components/np-design/components/NpPaginationDots"
import { useEmbla } from "src/utilities/embla"

export type NpProductCarouselProps = {
  listId: string
  products: NpHomePageProductData[]
  maxDisplayed?: number
}

export const NpProductCarousel = ({ listId, products, maxDisplayed }: NpProductCarouselProps) => {
  const { ref, embla, scrollSnaps, activeIndex, hasPrev, hasNext, justifyCenter } = useEmbla()

  return (
    <div className="mx-auto flex w-full max-w-323 flex-col items-center gap-10">
      <div className="embla relative w-full">
        <div
          ref={ref}
          className={clsx("embla__viewport overflow-hidden", {
            "cursor-grab active:cursor-grabbing": hasPrev || hasNext,
          })}
        >
          <div
            className={clsx("embla__container -ml-10 flex max-h-full", {
              "justify-center": justifyCenter,
            })}
          >
            {products.slice(0, maxDisplayed).map((data, index) => {
              return <NpProductCarouselItem key={index} listId={listId} data={data} />
            })}
          </div>
        </div>

        {hasPrev && (
          <div className="absolute top-1/2 left-4 hidden origin-top -translate-y-1/2 sm:block">
            <NpCarouselArrow side="left" onClick={() => embla?.scrollPrev()} />
          </div>
        )}
        {hasNext && (
          <div className="absolute top-1/2 right-4 hidden origin-top -translate-y-1/2 sm:block">
            <NpCarouselArrow side="right" onClick={() => embla?.scrollNext()} />
          </div>
        )}
      </div>

      {!justifyCenter && <NpPaginationDots count={scrollSnaps.length} activeIndex={activeIndex} />}
    </div>
  )
}
